var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCleaningBucket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5330_3254",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5330_3254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.3249 22C8.90824 22 8.5459 21.8667 8.2379 21.6C7.92924 21.3333 7.7499 21 7.6999 20.6L6.1499 9H17.8749L16.3249 20.6C16.2749 21 16.0959 21.3333 15.7879 21.6C15.4792 21.8667 15.1166 22 14.6999 22H9.3249ZM9.2999 21H14.6999C14.8666 21 15.0082 20.95 15.1249 20.85C15.2416 20.75 15.3082 20.6167 15.3249 20.45L16.6999 10H7.2749L8.6749 20.45C8.69157 20.6167 8.75824 20.75 8.8749 20.85C8.99157 20.95 9.13324 21 9.2999 21ZM11.9999 15.5C12.6999 15.5 13.2916 15.2583 13.7749 14.775C14.2582 14.2917 14.4999 13.7 14.4999 13V11.5H13.4999V13C13.4999 13.4167 13.3539 13.7707 13.0619 14.062C12.7706 14.354 12.4166 14.5 11.9999 14.5C11.5832 14.5 11.2292 14.354 10.9379 14.062C10.6459 13.7707 10.4999 13.4167 10.4999 13V11.5H9.4999V13C9.4999 13.7 9.74157 14.2917 10.2249 14.775C10.7082 15.2583 11.2999 15.5 11.9999 15.5ZM14.9999 6.975C14.7166 6.975 14.4792 6.879 14.2879 6.687C14.0959 6.49567 13.9999 6.25833 13.9999 5.975C13.9999 5.70833 14.0959 5.475 14.2879 5.275C14.4792 5.075 14.7166 4.975 14.9999 4.975C15.2832 4.975 15.5209 5.075 15.7129 5.275C15.9042 5.475 15.9999 5.70833 15.9999 5.975C15.9999 6.25833 15.9042 6.49567 15.7129 6.687C15.5209 6.879 15.2832 6.975 14.9999 6.975ZM9.9999 5.975C9.4499 5.975 8.97924 5.779 8.5879 5.387C8.1959 4.99567 7.9999 4.525 7.9999 3.975C7.9999 3.425 8.1959 2.954 8.5879 2.562C8.97924 2.17067 9.4499 1.975 9.9999 1.975C10.5666 1.975 11.0416 2.17067 11.4249 2.562C11.8082 2.954 11.9999 3.425 11.9999 3.975C11.9999 4.525 11.8082 4.99567 11.4249 5.387C11.0416 5.779 10.5666 5.975 9.9999 5.975ZM14.6999 21H8.6999H15.2999H14.6999Z",
    fill: "#151515"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleaningBucket);
export default __webpack_public_path__ + "static/media/CleaningBucket.480b7f9c2f654ca68aaff6b7c31923e7.svg";
export { ForwardRef as ReactComponent };